import { useTranslation } from "react-i18next";
import { FleetHero } from "~/components/fleet/FleetHero";
import { FleetProducts } from "~/components/fleet/FleetProducts";
import { FleetFeatureDeepDives } from "~/components/fleet/FleetFeatureDeepDives";
import { FleetRoi } from "~/components/fleet/FleetRoi";
import { FleetVehicleView } from "~/components/fleet/FleetVehicleView";
import { FleetPerformance } from "~/components/fleet/FleetPerformance";
import { FleetTrackingMatters } from "~/components/fleet/FleetTrackingMatters";
import { FleetPersonaRouter } from "~/components/fleet/FleetPersonaRouter";
import { FleetIntegrations } from "~/components/fleet/FleetIntegrations";
import { FleetFaq } from "~/components/fleet/FleetFaq";
import { FleetLastChance } from "~/components/fleet/FleetLastChance";

export const handle = { headerMode: "fleet", footerMode: "fleet", pageTheme: "fleet" };

export default function Fleet() {
  const { t } = useTranslation("fleet");
  return (
    <>
      <title>{t("title")}</title>
      <meta name="description" content={t("description")} />
      {/* Scopes the page body to the fleet tokens so it sits on the dark Bg-Primary. */}
      <div className="fleet bg-background text-text-body">
        <FleetHero />
        <FleetProducts />
        <FleetFeatureDeepDives />
        <FleetRoi />
        <FleetVehicleView />
        <FleetPerformance />
        <FleetTrackingMatters />
        <FleetPersonaRouter />
        <FleetIntegrations />
        <FleetFaq />
        <FleetLastChance />
      </div>
    </>
  );
}
